export class Fraction {
    public get percentage() {
        return this.value * 100;
    }

    constructor(public value: number) {}

    public static fromValue(value: number): Fraction {
        return new Fraction(value);
    }

    public static fromPercentage(percentage: number): Fraction {
        return new Fraction(percentage / 100);
    }

    public static fromValues(numerator: number, denominator: number): Fraction {
        return new Fraction(numerator / denominator);
    }

    static average(...fractions: Fraction[]): Fraction {
        if (fractions.length === 0) {
            return Fraction.fromValue(0);
        }
        const totalValue = fractions.reduce((total, fraction) => total + fraction.value, 0);
        return Fraction.fromValue(totalValue / fractions.length);
    }
}
